import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { errMsg } from "@/lib/medicoes";

export default function Manutencoes() {
  const [tabelas, setTabelas] = useState([]);
  const [tid, setTid] = useState("");
  const [f, setF] = useState({ referencia: "", q: "", tipo: "", page: 1 });
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/engenharia/tabelas").then((r) => {
      const s = r.data.items.filter((t) => t.status === "publicada" && t.fonte === "SINAPI-CE" && t.importacoes?.sinapi?.manutencoes);
      setTabelas(s);
      if (s[0]) setTid(s[0].id);
    });
  }, []);
  useEffect(() => {
    if (!tid) return undefined;
    const t = setTimeout(() => api.get(`/engenharia/tabelas/${tid}/manutencoes`, { params: { ...f, referencia: f.referencia || undefined, tipo: f.tipo || undefined } })
      .then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), 300);
    return () => clearTimeout(t);
  }, [tid, f]);
  const inp = "tce-input px-3 py-2.5 rounded-md text-sm";
  if (!tabelas.length) return <p className="text-sm text-[#94A3B8]" data-testid="manut-vazio">Nenhuma tabela SINAPI publicada com relatório de manutenções.</p>;
  return (
    <div className="space-y-4" data-testid="manutencoes">
      <div className="flex flex-wrap gap-2">
        <select data-testid="manut-tabela" value={tid} onChange={(e) => { setTid(e.target.value); setF({ ...f, referencia: "", page: 1 }); }} className={inp}>
          {tabelas.map((t) => <option key={t.id} value={t.id}>{`${t.fonte} · ${t.competencia || "s/ competência"} · ${t.regime}`}</option>)}
        </select>
        <select data-testid="manut-referencia" value={f.referencia || d?.referencia || ""} onChange={(e) => setF({ ...f, referencia: e.target.value, page: 1 })} className={inp}>
          {(d?.referencias || []).map((r) => <option key={r} value={r}>{r.split("-").reverse().join("/")}</option>)}
        </select>
        <select data-testid="manut-tipo" value={f.tipo} onChange={(e) => setF({ ...f, tipo: e.target.value, page: 1 })} className={inp}>
          <option value="">Insumos e composições</option><option value="INSUMO">Insumos</option><option value="COMPOSICAO">Composições</option>
        </select>
        <input data-testid="manut-q" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value, page: 1 })} placeholder="Código ou descrição…" className={`${inp} flex-1 min-w-[200px]`} />
      </div>
      <div className="flex flex-wrap gap-2" data-testid="manut-resumo">
        {d?.resumo.map((r) => <span key={r.manutencao} className="text-[11px] px-2.5 py-1 rounded-full bg-[#1E293B] border border-[#334155]">{r.manutencao}: <b className="text-[#FFDF00]">{r.total}</b></span>)}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-[#1E293B] text-left"><tr>{["Tipo", "Código", "Descrição", "Manutenção"].map((h) => <th key={h} className="px-3 py-2.5 uppercase-label !text-[10px]">{h}</th>)}</tr></thead>
          <tbody>
            {d?.items.map((m, i) => (
              <tr key={`${m.codigo}-${i}`} className="border-t border-[#334155]" data-testid={`manut-row-${i}`}>
                <td className="px-3 py-2">{m.tipo}</td><td className="px-3 py-2 font-mono text-[#FFDF00]">{m.codigo}</td>
                <td className="px-3 py-2">{m.descricao}</td><td className="px-3 py-2 whitespace-nowrap">{m.manutencao}</td>
              </tr>
            ))}
            {d && !d.items.length && <tr><td colSpan={4} className="px-3 py-6 text-center text-[#94A3B8]">Nenhuma manutenção encontrada.</td></tr>}
          </tbody>
        </table>
      </div>
      {d && d.total > 50 && (
        <div className="flex items-center gap-3 text-xs">
          <button disabled={f.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })} className="px-3 py-1 rounded border border-[#334155] disabled:opacity-30" data-testid="manut-prev">Anterior</button>
          <span>Página {f.page} de {Math.ceil(d.total / 50)} · {d.total} registros</span>
          <button disabled={f.page * 50 >= d.total} onClick={() => setF({ ...f, page: f.page + 1 })} className="px-3 py-1 rounded border border-[#334155] disabled:opacity-30" data-testid="manut-next">Próxima</button>
        </div>
      )}
    </div>
  );
}
